import graphql__3ac74a99fb373c79a5e2 from "./__generated__/RemoveSubscriptionAmountOverrideDialogMutation.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import {useRelayEnvironment} from "react-relay/hooks";
import {useIntl} from "react-intl";
import Section from "../form/Section";
import FormDialog from "./FormDialog";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";
import {useErrorContext} from "../../contexts/ErrorContext";
import type {RemoveSubscriptionAmountOverrideDialogMutation} from "./__generated__/RemoveSubscriptionAmountOverrideDialogMutation.graphql";

type Props = {
    override: {
        id: string
        subscription?: {
            subscriptionServiceReferenceLabel?: string | null
            customerAccount: {
                customerName: string
            }
        } | null
    }
    onClose: (changed: boolean) => void
}

const RemoveSubscriptionAmountOverrideDialog: React.FC<Props> = ({override, onClose}) => {
    const intl = useIntl();
    const relayEnvironment = useRelayEnvironment();
    const {addError} = useErrorContext();

    const handleSubmission = () => {
        commitMutationWithErrorHandling<RemoveSubscriptionAmountOverrideDialogMutation>(
            relayEnvironment,
            {
                mutation: graphql__3ac74a99fb373c79a5e2,
                variables: {input: {id: override.id}},
                onCompleted: (_, errors) => {
                    if (errors && errors.length > 0) {
                        console.error(errors);
                    }
                    onClose(true);
                },
                onError: (error) => {
                    console.error(error);
                    onClose(false);
                },
            },
            addError,
            {customErrorMessage: intl.formatMessage({id: 'errors.failedToRemoveSubscriptionAmountOverride'})}
        );
    };

    return (
        <FormDialog handleCloseDialog={() => onClose(false)}
                    handleSubmission={handleSubmission}
                    initialValues={{}}
                    headline={intl.formatMessage({id: 'dialog.RemoveSubscriptionAmountOverrideDialog.headline'})}
                    submitLabel={intl.formatMessage({id: 'button.delete'})}
                    dangerous={true}>
            <Section>
                <p className="text-sm text-gray-600">
                    {intl.formatMessage(
                        {id: 'dialog.RemoveSubscriptionAmountOverrideDialog.confirmMessage'},
                        {subscription: override.subscription ? override.subscription.customerAccount.customerName + ' · ' + (override.subscription.subscriptionServiceReferenceLabel ?? override.id) : override.id}
                    )}
                </p>
            </Section>
        </FormDialog>
    );
};

export default RemoveSubscriptionAmountOverrideDialog;
